export const SPARE_KEY_NUMBER_UNREGISTERED = "番号未登録"

export const SPARE_KEY_ROTATION_CONTACT_ADMIN =
    "キーローテができない場合は管理者に問い合わせてください"

/**
 * スペアキーの番号が分かっているかどうか。
 * 物件運営情報(BigQuery)に番号が無く確定済みの履歴も無い物件では、
 * m2m-cleaning が isRegistered=false（keyboxNumber は空文字）を返す。
 * isRegistered を返さない古い API でも同じ判定になるよう、番号の有無でも判定する。
 */
export const isSpareKeyNumberRegistered = (response: {
    isRegistered?: boolean
    keyboxNumber: string
}): boolean => (response.isRegistered ?? true) && response.keyboxNumber !== ""

/**
 * 清掃開始の前にスペアキーのローテーションを必須とするかどうか。
 * 番号未登録の物件は清掃員が変更前の番号を知る手段が無いため、ローテーションを待たずに
 * 清掃を開始できる（運用で許容。清掃員は管理者に問い合わせる）。
 */
export const isSpareKeyboxRotationRequired = (rotation: {
    isAvailable: boolean
    isRegistered: boolean
    isRotated: boolean
}): boolean =>
    rotation.isAvailable && (rotation.isRegistered || rotation.isRotated)
